import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { isNil, noop } from 'lodash'

import { SSN_PLACEHOLDER } from 'utils/constants/defaultValues'
import { formatSSN } from 'utils/formatters/ssn'
import { parseDigits } from 'utils/formatters/numbers'
import { SSNPlaceholder } from 'components/ssn/SSNPlaceholder'
import { FormBlock } from 'components/formBlock/FormBlock'
import { Input } from 'components/input/Input'

import styles from 'components/form/ssn/FormSSNView.module.scss'

export const FormSSNView = ({
  className,
  field,
  handleFieldChange,
  handleInputChange,
  handleShow,
  isDisabled,
  isHidden,
  isReadonly,
  isRequired,
  onChange,
  setInputRef,
  title,
}) => {
  const handleChange = onChange ? onChange : handleFieldChange ? handleFieldChange(field.name) : noop
  const isRequiredField = isNil(isRequired) ? field.isRequired : isRequired

  return (
    <FormBlock
      title={title}
      readonlyView={
        <SSNPlaceholder
          spacing={'\u00a0'}
          dataTestId="ssn-code"
          isHidden={isHidden}
          onClick={handleShow}
          placeholder={field.value}
          ssn={field.value}
        />
      }
      isReadonly={!!isReadonly}
      isRequired={!!isRequiredField}
      className={classNames(className)}>
      <Input
        type="text"
        placeholder={SSN_PLACEHOLDER}
        maxLength={15}
        value={formatSSN(field.value)}
        onChange={ssn => {
          const ssnValue = parseDigits(ssn)

          handleInputChange(ssnValue)
          handleChange(ssnValue)
        }}
        setInputRef={setInputRef}
        error={field.error}
        disabled={isDisabled}
        className={styles.input}
      />
    </FormBlock>
  )
}

FormSSNView.propTypes = {
  className: PropTypes.string,
  field: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func,
  handleInputChange: PropTypes.func,
  handleShow: PropTypes.func,
  isDisabled: PropTypes.bool,
  isHidden: PropTypes.bool,
  isReadonly: PropTypes.bool,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func,
  setInputRef: PropTypes.func.isRequired,
  title: PropTypes.node,
}
